import {
  formatNormalNumber,
  createKpiTileItem,
  formatPercentageValue,
} from '../../../../utils/helper';

export default {
  type: 'KpiTile',
  handler: (data) => {
    const { enabledBU, enabledBUDelta } = data.getPOReachMetrics;

    return createKpiTileItem(
      "Enabled BU's",
      formatNormalNumber(enabledBU),
      enabledBUDelta !== null && enabledBUDelta !== undefined
        ? {
            isPositiveValue: enabledBUDelta >= 0,
            text: formatPercentageValue(Math.abs(enabledBUDelta)),
            sideLabel: '',
            showArrow: Number(enabledBUDelta) !== 0,
          }
        : null
    );
  },
};
